import _ from 'lodash';

function getOtherRedlined(blocks, dealChanges) {
  let isOtherRedlined = false;

  for (let i = 0; i < dealChanges.length; i++) {
    const dealChange = dealChanges[i];
    if (dealChange.type === 'agreement-text-sentence') {
      const changes = JSON.parse(dealChange.changes);

      if (changes && changes.sentence) {
        const changesSection = changes.sentence.section.replace(/\s/g, '');
        const otherChange = _.find(
          blocks,
          (block) =>
            block.name.replace(/\s/g, '') === changesSection ||
            `${block.name.replace(/\s/g, '')}title` === changesSection
        );
        if (!otherChange) {
          isOtherRedlined = true;
          break;
        }
      }
    }
  }

  return isOtherRedlined;
}

export default getOtherRedlined;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/helpers/getOtherRedlined.js